import React, { useState, useEffect } from 'react';
import { ContainerBanner, Banner } from './Home.style.js';

import apiService from '../api/home'; 


function BannerPage({Item}) {

    const getAmbiente =  apiService.ambiente();
    var get_item_url = Item.urlbanneritem;
    var url = getAmbiente+"/"+get_item_url

    return (
        <ContainerBanner>
            <Banner><img style={{width:'100%',height:'100%', borderRadius:20,objectFit: 'contain'}} src={url}></img></Banner>
        </ContainerBanner>   
    );
}

export default BannerPage;
